import { createZipExport } from './zipExport';
import { createKMLExport, createKMZExport } from './kmlExport';
import { createGeoJSONExport } from './geojsonExport';
import { createGPXExport } from './gpxExport';
import { logError, logInfo } from '../logger';

const SUPPORTED_FORMATS = ['geojson', 'kml', 'kmz', 'gpx', 'zip'];

export const exportData = async (survey, format, options = {}) => {
  if (!survey) {
    throw new Error('No survey data to export');
  }

  if (!SUPPORTED_FORMATS.includes(format)) {
    throw new Error(`Unsupported export format: ${format}. Supported formats are: ${SUPPORTED_FORMATS.join(', ')}`);
  }

  try {
    let data;
    let mimeType;
    let fileExtension;

    switch (format.toLowerCase()) {
      case 'geojson':
        data = await createGeoJSONExport(survey);
        mimeType = 'application/json';
        fileExtension = 'geojson';
        break;

      case 'kml':
        data = await createKMLExport(survey);
        mimeType = 'application/vnd.google-earth.kml+xml';
        fileExtension = 'kml';
        break;

      case 'kmz':
        data = await createKMZExport(survey);
        mimeType = 'application/vnd.google-earth.kmz';
        fileExtension = 'kmz';
        break;

      case 'gpx':
        data = await createGPXExport(survey);
        mimeType = 'application/gpx+xml';
        fileExtension = 'gpx';
        break;

      case 'zip':
        data = await createZipExport(survey, options);
        mimeType = 'application/zip';
        fileExtension = 'zip';
        break;

      default:
        throw new Error(`Unsupported export format: ${format}`);
    }

    if (!data) {
      throw new Error('No data generated for export');
    }

    logInfo(`Survey exported successfully as ${format}`);
    return new Blob([data], { type: mimeType });
  } catch (error) {
    logError('Export failed:', error);
    throw new Error(`Failed to export survey: ${error.message}`);
  }
};